module.exports = __webpack_public_path__ + "static/realtor-d2602c3866466664264ddb06665920d8.svg";